// import React, { useState, useEffect, useRef } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, Play, Pause } from 'lucide-react';
// import { Link } from 'react-router-dom';

// const VideoAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [showControls, setShowControls] = useState(false);
//   const videoRef = useRef(null);

//   const handlePlayPause = () => {
//     if (videoRef.current) {
//       if (isPlaying) {
//         videoRef.current.pause();
//       } else {
//         videoRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   const handleExpand = () => {
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   return (
//     <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact Video Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full`}
//             onClick={handleExpand}
//             onMouseEnter={() => setShowControls(true)}
//             onMouseLeave={() => setShowControls(false)}
//           >
//             {/* Video Container */}
//             <div className="relative w-full h-full  overflow-hidden">
//               <video
//                 ref={videoRef}
//                 className="w-full h-full object-cover"
//                 muted
//                 loop
//                 playsInline
//                 autoPlay
//                 // onPlay={() => setIsPlaying(true)}
//                 // onPause={() => setIsPlaying(false)}
//               >
//                 <source src="/assets/prism.MP4" type="video/mp4" />
//                 Your browser does not support the video tag.
//               </video>

//               {/* Play/Pause Overlay */}
//               {/* <div 
//                 className={`absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center transition-opacity duration-300 ${
//                   showControls || !isPlaying ? 'opacity-100' : 'opacity-0'
//                 }`}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handlePlayPause();
//                 }}
//               > */}
//                 {/* <div className="w-12 h-12 bg-white bg-opacity-80 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all duration-200">
//                   {isPlaying ? (
//                     <Pause size={24} className="text-gray-800" />
//                   ) : (
//                     <Play size={24} className="text-gray-800 ml-1" />
//                   )}
//                 </div> */}
//               {/* </div> */}

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
//                 AD
//               </div>

//               {/* Brand/CTA Overlay */}
//               {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/50 to-transparent p-3">
//                 <div className="text-white">
//                   <h4 className="font-bold text-sm mb-1">Premium Content</h4>
//                   <p className="text-xs text-white/80 mb-2">Experience the difference</p>
//                   <button className="bg-white text-black px-3 py-1 rounded-full text-xs font-medium hover:bg-gray-200 transition-colors">
//                     Learn More
//                   </button>
//                 </div>
//               </div> */}
//             </div>

//             {/* Click to expand hint */}
//             {/* {!isInPreview && showControls && (
//               <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//                 <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
//                   Click to expand!
//                 </div>
//               </div>
//             )} */}
//           </div>
//         </div>
//       ) : (
//         /* Expanded Video Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           {/* <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button> */}
          
//           <div className="relative w-full h-full max-w-4xl">
//             <video
//               ref={videoRef}
//               className="w-full h-full object-contain"
//               controls
//               autoPlay
//               muted
//               loop
//               playsInline
//             >
//               <source src="/assets/prism.MP4" type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>

//             {/* Brand overlay for expanded view */}
//             {/* <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg p-4 text-white">
//               <h3 className="text-xl font-bold mb-2">Premium Experience</h3>
//               <p className="text-sm opacity-80 mb-3">Discover what makes us different</p>
//               <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-200 transition-colors">
//                 Get Started
//               </button>
//             </div> */}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// function Ad11() {
//   const [isMobile, setIsMobile] = useState(true);
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//     <div className="min-h-screen bg-gray-50 mt-10">
//       <div className="container mx-auto px-4 py-8 lg:py-12">
//         <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//           {/* Left column - Content */}
//           <div className="flex-1 lg:max-w-lg">
//             {/* Header */}
//             <header className="animate-slide-up">
//               {/* Back to Ad Gallery */}
//               <div className="mb-6 lg:mb-8">
//                 {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
//                   <span className="text-sm font-medium">Back to Ad Gallery</span>
//                 </button> */}
//               </div>

//               {/* Title and tag */}
//               <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                 <div className="flex flex-wrap items-center gap-3 mb-3">
//                   <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                   Showcase in Every Angle. Impress in Every Frame.

//                   </h1>
//                   <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                   3D Prism
//                   </span>
//                 </div>
                
//                 {/* View in preview site */}
//                 {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <Eye className="w-4 h-4" />
//                   <span className="text-sm font-medium group-hover:underline">View in preview site</span>
//                 </button> */}
//               </div>
//             </header>

//             {/* Content Section */}
//             <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//               {/* Make it yours section */}
//               <div className="mb-8">
//                 <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                 TURN HEADS INSTANTLY
//                 </h2>
//                 <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                 This 3D prism ad transforms your creative into a rotating visual centerpiece. As the prism spins, your video plays across dynamic panels—adding depth, motion, and impact. Just drop in your content and logo to launch a striking, high-attention format that stops the scroll and pulls viewers in.
//                 </p>
                
//                 {/* CTA Button */}
//                 <Link to='/contact'>
//                                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                   <span>Start with this Template</span>
//                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                 </button>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Right column - Template Preview */}
//           <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//             {/* Preview toggle */}
//             <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
//               <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
//                 <div className="flex items-center space-x-4">
//                   {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
//                   <div className="flex items-center space-x-3">
//                     <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                       Mobile
//                     </span>
//                     <button
//                       onClick={() => setIsMobile(!isMobile)}
//                       className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                     >
//                       <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                     </button>
//                     <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                       Desktop
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//               {/* Mobile Mockup */}
//               {isMobile && (
//                 <div className="mx-auto max-w-xs">
//                   {/* iPhone mockup */}
//                   <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                         <span>9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm relative">
//                             <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                           publisher.com
//                         </div>
//                       </div>

//                       {/* Content area */}
//                       <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
//                       <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
                          

//                         </div>
//                         {/* Video Ad - Full width on mobile with same gap from top */}
//                         <div className="mb-6">
//                           <div className="h-48 rounded-lg overflow-hidden">
//                             <VideoAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         {/* Additional content placeholders */}
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
                         

//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Desktop Mockup */}
//               {!isMobile && (
//                 <div className="w-full max-w-2xl mx-auto">
//                   {/* Desktop Screen Frame */}
//                   <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
//                     {/* Screen */}
//                     <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
//                       {/* macOS-style window header */}
//                       <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
//                         <div className="flex space-x-2">
//                           <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                           <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                           <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                         </div>
//                         <div className="flex-1 mx-6">
//                           <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
//                             🔒 publisher.com
//                           </div>
//                         </div>
//                         <div className="flex space-x-1">
//                           <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                           <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                         </div>
//                       </div>

//                       {/* Browser content area */}
//                       <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
//                         {/* Page header */}
//                         <div className="mb-2">
//                           <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
//                           <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//                         </div>

//                         {/* Video Ad positioned in content with same gap from top */}
//                         {/* <div className="flex justify-center mb-2">
//                           <div className="w-80 h-48  overflow-hidden"> */}
//                               <div className="flex justify-center ">
//                               <div className="w-full h-64 max-w-sm ">
//                             <VideoAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>

//                         {/* Additional content placeholders */}
//                         <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>

//                         {/* Sidebar placeholders */}
//                         <div className="grid grid-cols-3 gap-4">
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                         </div>
//                          {/* Additional content placeholders */}
//                          <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>

//                         {/* Sidebar placeholders */}
//                         <div className="grid grid-cols-3 gap-4">
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                         </div>
//                         <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>
//                         <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
                  
//                   {/* Monitor stand */}
//                   <div className="flex justify-center">
//                     <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
//                   </div>
//                   <div className="flex justify-center">
//                     <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Expanded Video Overlay */}
//       {isExpanded && (
//         <div className="fixed inset-0 z-50">
//           <VideoAdContent 
//             isExpanded={true}
//             onClose={() => setIsExpanded(false)}
//           />
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes slide-up {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
        
//         .animate-slide-up {
//           animation: slide-up 0.6s ease-out forwards;
//         }
        
//         .animate-fade-in {
//           animation: fade-in 0.6s ease-out forwards;
//         }
//       `}</style>
//     </div>

    // <div className="max-w-7xl mx-auto px-4 py-10">
    //       <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
    
    //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
    //         {/* Card 1 */}
    //         <Link to="/ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //           <img
    //             src="/assets/rama.webp"
    //             alt="Card 1"
    //             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //           />
    //           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //             <h2 className="text-lg font-semibold">Ramadan</h2>
    //           </div>
    //         </Link>
    
    //         {/* Card 2 */}
    //         <Link to="/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //           <img
    //             src="/assets/zakat.webp"
    //             alt="Card 2"
    //             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //           />
    //           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //             <h2 className="text-lg font-semibold">Zakat Calculator</h2>
    //           </div>
    //         </Link>
    
    //         {/* Card 3 */}
    //         <Link to="/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //           <img
    //             src="/assets/donate.avif"
    //             alt="Card 3"
    //             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //           />
    //           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //             <h2 className="text-lg font-semibold">Donation</h2>
    //           </div>
    //         </Link>
    
    //         {/* Card 4 */}
    //         <Link to="/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //           <img
    //             src="/assets/mam1.jpg"
    //             alt="Card 4"
    //             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //           />
    //           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //             <h2 className="text-lg font-semibold">Mama Earth</h2>
    //           </div>
    //         </Link>
    
           
    //       </div>
    //     </div>
//     </>
//   );
// }

// export default Ad11;    
    
// import React, { useState, useRef, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight } from 'lucide-react';

// const images = [
//   "/assets/prism.png",
//   "/assets/prism2.png", 
//   "/assets/prism3.png",
// ];

// const Prism3DAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [rotation, setRotation] = useState(0);
//   const [showControls, setShowControls] = useState(false);
//   const containerRef = useRef(null);
//   const intervalRef = useRef(null);
//   const step = 120;

//   // Auto-rotate
//   useEffect(() => {
//     startAutoRotate();
//     return stopAutoRotate;
//   }, []);

//   const startAutoRotate = () => {
//     intervalRef.current = setInterval(() => {
//       setRotation((prev) => prev - step);
//     }, 3000);
//   };

//   const stopAutoRotate = () => {
//     clearInterval(intervalRef.current);
//   };

//   // Pause on hover
//   const handleMouseEnter = () => {
//     setShowControls(true);
//     stopAutoRotate();
//   };
  
//   const handleMouseLeave = () => {
//     setShowControls(false);
//     startAutoRotate();
//   };

//   // Drag to rotate
//   let startX = 0;
//   const handleMouseDown = (e) => {
//     if (isInPreview) return;
//     stopAutoRotate();
//     startX = e.clientX;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     const deltaX = e.clientX - startX;
//     if (Math.abs(deltaX) > 50) {
//       setRotation((prev) => prev + (deltaX > 0 ? step : -step));
//       startX = e.clientX;
//     }
//   };

//   const handleMouseUp = () => {
//     startAutoRotate();
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   const handleExpand = () => {
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   const prismSize = isExpanded ? { width: 400, height: 550 } : { width: 200, height: 275 };

//   return (
//     <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact 3D Prism Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full flex items-center justify-center`}
//             onClick={handleExpand}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           >
//             {/* 3D Prism Container */}
//             <div 
//               className="relative"
//               style={{ 
//                 width: `${prismSize.width}px`, 
//                 height: `${prismSize.height}px`,
//                 perspective: '1000px'
//               }}
//               onMouseDown={handleMouseDown}
//               ref={containerRef}
//             >
//               <div
//                 className="w-full h-full relative transition-transform duration-700"
//                 style={{
//                   transformStyle: "preserve-3d",
//                   transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
//                 }}
//               >
//                 {images.map((src, i) => (
//                   <div
//                     key={i}
//                     className="absolute overflow-hidden rounded-xl shadow-xl"
//                     style={{
//                       width: `${prismSize.width}px`,
//                       height: `${prismSize.height}px`,
//                       transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
//                     }}
//                   >
//                     <img
//                       src={src}
//                       alt={`prism-face-${i}`}
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 ))}
//               </div>

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium z-10">
//                 AD
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded 3D Prism Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div 
//             className="relative"
//             style={{ 
//               width: `${prismSize.width}px`, 
//               height: `${prismSize.height}px`,
//               perspective: '1000px'
//             }}
//             onMouseDown={handleMouseDown}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//             ref={containerRef}
//           >
//             <div
//               className="w-full h-full relative transition-transform duration-700"
//               style={{
//                 transformStyle: "preserve-3d",
//                 transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
//               }}
//             >
//               {images.map((src, i) => (
//                 <div
//                   key={i}
//                   className="absolute overflow-hidden rounded-xl shadow-xl"
//                   style={{
//                     width: `${prismSize.width}px`,
//                     height: `${prismSize.height}px`,
//                     transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
//                   }}
//                 >
//                   <img
//                     src={src}
//                     alt={`prism-face-${i}`}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Brand overlay for expanded view */}
//             <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg p-4 text-white">
//               <h3 className="text-xl font-bold mb-2">Premium Experience</h3>
//               <p className="text-sm opacity-80 mb-3">Discover what makes us different</p>
//               <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-200 transition-colors">
//                 Get Started
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// function Ad11() {
//   const [isMobile, setIsMobile] = useState(true);
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50 mt-10">
//         <div className="container mx-auto px-4 py-8 lg:py-12">
//           <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//             {/* Left column - Content */}
//             <div className="flex-1 lg:max-w-lg">
//               {/* Header */}
//               <header className="animate-slide-up">
//                 {/* Back to Ad Gallery */}
//                 <div className="mb-6 lg:mb-8">
//                   {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                     <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
//                     <span className="text-sm font-medium">Back to Ad Gallery</span>
//                   </button> */}
//                 </div>

//                 {/* Title and tag */}
//                 <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                   <div className="flex flex-wrap items-center gap-3 mb-3">
//                     <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                       Showcase in Every Angle. Impress in Every Frame.
//                     </h1>
//                     <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                       3D Prism
//                     </span>
//                   </div>
                  
//                   {/* View in preview site */}
//                   {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                     <Eye className="w-4 h-4" />
//                     <span className="text-sm font-medium group-hover:underline">View in preview site</span>
//                   </button> */}
//                 </div>
//               </header>

//               {/* Content Section */}
//               <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//                 {/* Make it yours section */}
//                 <div className="mb-8">
//                   <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                     TURN HEADS INSTANTLY
//                   </h2>
//                   <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                     This 3D prism ad transforms your creative into a rotating visual centerpiece. As the prism spins, your images display across dynamic panels—adding depth, motion, and impact. Just drop in your content and logo to launch a striking, high-attention format that stops the scroll and pulls viewers in.
//                   </p>
                  
//                   {/* CTA Button */}
//                   <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                     <span>Start with this Template</span>
//                     <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right column - Template Preview */}
//             <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//               {/* Preview toggle */}
//               <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
//                 <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
//                   <div className="flex items-center space-x-4">
//                     <div className="flex items-center space-x-3">
//                       <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Mobile
//                       </span>
//                       <button
//                         onClick={() => setIsMobile(!isMobile)}
//                         className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                       >
//                         <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                       </button>
//                       <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Desktop
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//                 {/* Mobile Mockup */}
//                 {isMobile && (
//                   <div className="mx-auto max-w-xs">
//                     {/* iPhone mockup */}
//                     <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
//                       {/* Status bar area */}
//                       <div className="bg-white rounded-[2rem] overflow-hidden">
//                         {/* Status bar */}
//                         <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                           <span>9:41</span>
//                           <div className="flex items-center space-x-1">
//                             <div className="flex space-x-1">
//                               <div className="w-1 h-1 bg-black rounded-full"></div>
//                               <div className="w-1 h-1 bg-black rounded-full"></div>
//                               <div className="w-1 h-1 bg-black rounded-full"></div>
//                               <div className="w-1 h-1 bg-black rounded-full"></div>
//                             </div>
//                             <div className="w-6 h-3 border border-black rounded-sm relative">
//                               <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Browser bar */}
//                         <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                           <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                             publisher.com
//                           </div>
//                         </div>

//                         {/* Content area */}
//                         <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
//                           <div className="space-y-3">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           </div>
                          
//                           {/* 3D Prism Ad - Full width on mobile with same gap from top */}
//                           <div className="mb-6">
//                             <div className="h-48 rounded-lg overflow-hidden">
//                               <Prism3DAdContent 
//                                 isInPreview={true}
//                                 isExpanded={isExpanded}
//                                 onExpand={() => setIsExpanded(true)}
//                                 onClose={() => setIsExpanded(false)}
//                               />
//                             </div>
//                           </div>
                          
//                           <div className="space-y-3">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3 mt-2">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3 mt-2">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3 mt-2">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           {/* Additional content placeholders */}
//                           <div className="space-y-3">
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Desktop Mockup */}
//                 {!isMobile && (
//                   <div className="w-full max-w-2xl mx-auto">
//                     {/* Desktop Screen Frame */}
//                     <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
//                       {/* Screen */}
//                       <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
//                         {/* macOS-style window header */}
//                         <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
//                           <div className="flex space-x-2">
//                             <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                             <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                             <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                           </div>
//                           <div className="flex-1 mx-6">
//                             <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
//                               🔒 publisher.com
//                             </div>
//                           </div>
//                           <div className="flex space-x-1">
//                             <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                             <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                           </div>
//                         </div>

//                         {/* Browser content area */}
//                         <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
//                           {/* Page header */}
//                           <div className="mb-2">
//                             <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
//                             <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//                           </div>

//                           {/* 3D Prism Ad positioned in content with same gap from top */}
//                           <div className="flex justify-center ">
//                             <div className="w-full h-64 max-w-sm ">
//                               <Prism3DAdContent 
//                                 isInPreview={true}
//                                 isExpanded={isExpanded}
//                                 onExpand={() => setIsExpanded(true)}
//                                 onClose={() => setIsExpanded(false)}
//                               />
//                             </div>
//                           </div>

//                           {/* Additional content placeholders */}
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                           </div>

//                           {/* Sidebar placeholders */}
//                           <div className="grid grid-cols-3 gap-4">
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                           </div>
//                           {/* Additional content placeholders */}
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                           </div>

//                           {/* Sidebar placeholders */}
//                           <div className="grid grid-cols-3 gap-4">
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                           </div>
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                           </div>
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-200 rounded w-full"></div>
//                               <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
                    
//                     {/* Monitor stand */}
//                     <div className="flex justify-center">
//                       <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
//                     </div>
//                     <div className="flex justify-center">
//                       <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Expanded 3D Prism Overlay */}
//         {isExpanded && (
//           <div className="fixed inset-0 z-50">
//             <Prism3DAdContent 
//               isExpanded={true}
//               onClose={() => setIsExpanded(false)}
//             />
//           </div>
//         )}

//         <style jsx>{`
//           @keyframes slide-up {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           @keyframes fade-in {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }
          
//           .animate-slide-up {
//             animation: slide-up 0.6s ease-out forwards;
//           }
          
//           .animate-fade-in {
//             animation: fade-in 0.6s ease-out forwards;
//           }

//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//           }
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//         `}</style>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 py-10">
//         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {/* Card 1 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/rama.webp"
//               alt="Card 1"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Ramadan</h2>
//             </div>
//           </div>

//           {/* Card 2 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/zakat.webp"
//               alt="Card 2"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Zakat Calculator</h2>
//             </div>
//           </div>

//           {/* Card 3 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/donate.avif"
//               alt="Card 3"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Donation</h2>
//             </div>
//           </div>

//           {/* Card 4 */}
//           <div className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
//             <img
//               src="/assets/mam1.jpg"
//               alt="Card 4"
//               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
//             />
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Mama Earth</h2>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Ad11;

    
import React, { useState, useRef, useEffect } from 'react';
import { ArrowLeft, Eye, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const images = [
  "/assets/prism11.jpg",
  "/assets/prism12.jpg", 
  "/assets/prism13.jpg",
];

// const Prism3DAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [rotation, setRotation] = useState(0);
//   const [showControls, setShowControls] = useState(false);
//   const containerRef = useRef(null);
//   const intervalRef = useRef(null);
//   const step = 120;

//   // Auto-rotate
//   useEffect(() => {
//     startAutoRotate();
//     return stopAutoRotate;
//   }, []);

//   const startAutoRotate = () => {
//     intervalRef.current = setInterval(() => {
//       setRotation((prev) => prev - step);
//     }, 3000);
//   };

//   const stopAutoRotate = () => {
//     clearInterval(intervalRef.current);
//   };

//   // Manual rotation controls
//   const rotateLeft = () => {
//     stopAutoRotate();
//     setRotation((prev) => prev + step);
//     setTimeout(startAutoRotate, 2000);
//   };

//   const rotateRight = () => {
//     stopAutoRotate();
//     setRotation((prev) => prev - step);
//     setTimeout(startAutoRotate, 2000);
//   };

//   // Pause on hover
//   const handleMouseEnter = () => {
//     setShowControls(true);
//     stopAutoRotate();
//   };
  
//   const handleMouseLeave = () => {
//     setShowControls(false);
//     startAutoRotate();
//   };

//   // Drag to rotate
//   let startX = 0;
//   const handleMouseDown = (e) => {
//     stopAutoRotate();
//     startX = e.clientX;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     const deltaX = e.clientX - startX;
//     if (Math.abs(deltaX) > 50) {
//       setRotation((prev) => prev + (deltaX > 0 ? step : -step));
//       startX = e.clientX;
//     }
//   };

//   const handleMouseUp = () => {
//     startAutoRotate();
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   const handleExpand = () => {
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   const prismSize = isExpanded ? { width: 400, height: 550 } : { width: 200, height: 275 };

//   return (
//     <div className={` w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact 3D Prism Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full flex items-center justify-center`}
//             onClick={handleExpand}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           >
//             {/* 3D Prism Container */}
//             <div 
//               className="relative"
//               style={{ 
//                 width: `${prismSize.width}px`, 
//                 height: `${prismSize.height}px`,
//                 perspective: '1000px'
//               }}
//               onMouseDown={handleMouseDown}
//               ref={containerRef}
//             >
//               <div
//                 className="w-full h-full relative transition-transform duration-700"
//                 style={{
//                   transformStyle: "preserve-3d",
//                   transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
//                 }}
//               >
//                 {images.map((src, i) => (
//                   <div
//                     key={i}
//                     className="absolute overflow-hidden rounded-xl shadow-xl"
//                     style={{
//                       width: `${prismSize.width}px`,
//                       height: `${prismSize.height}px`,
//                       transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
//                     }}
//                   >
//                     <img
//                       src={src}
//                       alt={`prism-face-${i}`}
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 ))}
//               </div>

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium z-10">
//                 AD
//               </div>

//               {/* Manual Rotation Controls - Show on hover */}
//               {showControls && (
//                 <div className="absolute inset-0 flex items-center justify-between px-4 z-10 pointer-events-none">
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       rotateLeft();
//                     }}
//                     className="w-10 h-10 bg-black/40 hover:bg-black/60 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110 pointer-events-auto"
//                   >
//                     ←
//                   </button>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       rotateRight();
//                     }}
//                     className="w-10 h-10 bg-black/40 hover:bg-black/60 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110 pointer-events-auto"
//                   >
//                     →
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded 3D Prism Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div 
//             className="relative"
//             style={{ 
//               width: `${prismSize.width}px`, 
//               height: `${prismSize.height}px`,
//               perspective: '1000px'
//             }}
//             onMouseDown={handleMouseDown}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//             ref={containerRef}
//           >
//             <div
//               className="w-full h-full relative transition-transform duration-700"
//               style={{
//                 transformStyle: "preserve-3d",
//                 transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
//               }}
//             >
//               {images.map((src, i) => (
//                 <div
//                   key={i}
//                   className="absolute overflow-hidden rounded-xl shadow-xl"
//                   style={{
//                     width: `${prismSize.width}px`,
//                     height: `${prismSize.height}px`,
//                     transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
//                   }}
//                 >
//                   <img
//                     src={src}
//                     alt={`prism-face-${i}`}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Brand overlay for expanded view */}
//             {/* <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg p-4 text-white">
//               <h3 className="text-xl font-bold mb-2">Premium Experience</h3>
//               <p className="text-sm opacity-80 mb-3">Discover what makes us different</p>
//               <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-200 transition-colors">
//                 Get Started
//               </button>
//             </div> */}

//             {/* Manual Rotation Controls for expanded view */}
//             <div className="absolute inset-0 flex items-center justify-between px-8 z-10">
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   rotateLeft();
//                 }}
//                 className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl transition-all duration-200 hover:scale-110"
//               >
//                 ←
//               </button>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   rotateRight();
//                 }}
//                 className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl transition-all duration-200 hover:scale-110"
//               >
//                 →
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
const Prism3DAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [rotation, setRotation] = useState(0);
  const [showControls, setShowControls] = useState(false);
  const [isAutoRotating, setIsAutoRotating] = useState(true);
  const containerRef = useRef(null);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const step = 120;

  // Auto-rotate
  useEffect(() => {
    startAutoRotate();
    return () => {
      stopAutoRotate();
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const startAutoRotate = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setIsAutoRotating(true);
    intervalRef.current = setInterval(() => {
      setRotation((prev) => prev - step);
    }, 3000);
  };

  const stopAutoRotate = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsAutoRotating(false);
  };

  // Solution 1: Smoother manual rotation with longer delay
  const rotateLeft = () => {
    stopAutoRotate();
    setRotation((prev) => prev + step);
    
    // Clear any existing timeout
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    // Resume auto-rotation after a longer delay
    timeoutRef.current = setTimeout(() => {
      startAutoRotate();
    }, 4000); // Increased from 2000ms to 4000ms
  };

  const rotateRight = () => {
    stopAutoRotate();
    setRotation((prev) => prev - step);
    
    // Clear any existing timeout
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    // Resume auto-rotation after a longer delay
    timeoutRef.current = setTimeout(() => {
      startAutoRotate();
    }, 4000); // Increased from 2000ms to 4000ms
  };

  // Alternative Solution 2: Sync with auto-rotation timing
  const rotateLeftSync = () => {
    stopAutoRotate();
    setRotation((prev) => prev + step);
    
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    // Wait for the transition to complete, then start auto-rotation
    // with a delay that syncs better with the 3-second interval
    timeoutRef.current = setTimeout(() => {
      // Reset to start the cycle fresh
      startAutoRotate();
    }, 3000); // Match the auto-rotation interval
  };

  const rotateRightSync = () => {
    stopAutoRotate();
    setRotation((prev) => prev - step);
    
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    timeoutRef.current = setTimeout(() => {
      startAutoRotate();
    }, 3000); // Match the auto-rotation interval
  };

  // Pause on hover
  const handleMouseEnter = () => {
    setShowControls(true);
    stopAutoRotate();
  };
  
  const handleMouseLeave = () => {
    setShowControls(false);
    // Only restart if we're not in a manual rotation timeout
    if (!timeoutRef.current) {
      startAutoRotate();
    }
  };

  // Drag to rotate
  let startX = 0;
  const handleMouseDown = (e) => {
    stopAutoRotate();
    startX = e.clientX;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const deltaX = e.clientX - startX;
    if (Math.abs(deltaX) > 50) {
      setRotation((prev) => prev + (deltaX > 0 ? step : -step));
      startX = e.clientX;
    }
  };

  const handleMouseUp = () => {
    // Delay auto-rotation restart after drag
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      startAutoRotate();
    }, 2000);
    
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleExpand = () => {
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };

  const prismSize = isExpanded ? { width: 400, height: 550 } : { width: 200, height: 275 };

  return (
    <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
      {!isExpanded ? (
        <div className="relative h-full">
          <div 
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? 'hover:scale-105' : ''
            } w-full h-full flex items-center justify-center`}
            onClick={handleExpand}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div 
              className="relative"
              style={{ 
                width: `${prismSize.width}px`, 
                height: `${prismSize.height}px`,
                perspective: '1000px'
              }}
              onMouseDown={handleMouseDown}
              ref={containerRef}
            >
              <div
                className="w-full h-full relative transition-transform duration-700 ease-in-out"
                style={{
                  transformStyle: "preserve-3d",
                  transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
                }}
              >
                {images.map((src, i) => (
                  <div
                    key={i}
                    className="absolute overflow-hidden rounded-xl shadow-xl"
                    style={{
                      width: `${prismSize.width}px`,
                      height: `${prismSize.height}px`,
                      transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
                    }}
                  >
                    <img
                      src={src}
                      alt={`prism-face-${i}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>

              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium z-10">
                AD
              </div>

              {/* Auto-rotation indicator */}
              <div className="absolute top-2 right-2 z-10">
                <div className={`w-2 h-2 rounded-full ${isAutoRotating ? 'bg-green-400' : 'bg-gray-400'} animate-pulse`}></div>
              </div>

              {showControls && (
                <div className="absolute inset-0 flex items-center justify-between px-4 z-10 pointer-events-none">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      rotateLeftSync(); // Using the sync version
                    }}
                    className="w-10 h-10 bg-black/40 hover:bg-black/60 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110 pointer-events-auto"
                  >
                    ←
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      rotateRightSync(); // Using the sync version
                    }}
                    className="w-10 h-10 bg-black/40 hover:bg-black/60 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110 pointer-events-auto"
                  >
                    →
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex items-center justify-center relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
          >
            ×
          </button>
          
          <div 
            className="relative"
            style={{ 
              width: `${prismSize.width}px`, 
              height: `${prismSize.height}px`,
              perspective: '1000px'
            }}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={containerRef}
          >
            <div
              className="w-full h-full relative transition-transform duration-700 ease-in-out"
              style={{
                transformStyle: "preserve-3d",
                transform: `translateZ(-${prismSize.width * 0.83}px) rotateY(${rotation}deg)`,
              }}
            >
              {images.map((src, i) => (
                <div
                  key={i}
                  className="absolute overflow-hidden rounded-xl shadow-xl"
                  style={{
                    width: `${prismSize.width}px`,
                    height: `${prismSize.height}px`,
                    transform: `rotateY(${i * 120}deg) translateZ(${prismSize.width * 0.83}px)`,
                  }}
                >
                  <img
                    src={src}
                    alt={`prism-face-${i}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            <div className="absolute inset-0 flex items-center justify-between px-8 z-10">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  rotateLeftSync();
                }}
                className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl transition-all duration-200 hover:scale-110"
              >
                ←
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  rotateRightSync();
                }}
                className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl transition-all duration-200 hover:scale-110"
              >
                →
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function Ad11() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>

     <Helmet>
       {/* <title>
       Bidbox Ad Gallery | Showcase Targeted Campaign Creativity
        </title>
        <meta
          name="description"
          content="Explore Bidbox’s Ad Gallery – see powerful, targeted ad campaigns in action. Get inspired & elevate your advertising with DSP strategy insights."
        /> */}
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/3d-prism/prism"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
      <div className="min-h-screen bg-gray-50 mt-10">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
            {/* Left column - Content */}
            <div className="flex-1 lg:max-w-lg">
              {/* Header */}
              <header className="animate-slide-up">
                {/* Back to Ad Gallery */}
                <div className="mb-6 lg:mb-8">
                  {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                    <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
                    <span className="text-sm font-medium">Back to Ad Gallery</span>
                  </button> */}
                </div>

                {/* Title and tag */}
                <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                      Showcase in Every Angle. Impress in Every Frame.
                    </h1>
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                      3D Prism
                    </span>
                  </div>
                  
                  {/* View in preview site */}
                  {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                    <Eye className="w-4 h-4" />
                    <span className="text-sm font-medium group-hover:underline">View in preview site</span>
                  </button> */}
                </div>
              </header>

              {/* Content Section */}
              <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
                {/* Make it yours section */}
                <div className="mb-8">
                  <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                    TURN HEADS INSTANTLY
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                    This 3D prism ad transforms your creative into a rotating visual centerpiece. As the prism spins, your images display across dynamic panels—adding depth, motion, and impact. Just drop in your content and logo to launch a striking, high-attention format that stops the scroll and pulls viewers in.
                  </p>
                  
                  {/* CTA Button */}
                  <Link to="/contact">
                  <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                    <span>Start with this Template</span>
                    <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                  </button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Right column - Template Preview */}
            <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
              {/* Preview toggle */}
              <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
                {/* Mobile Mockup */}
                {isMobile && (
                  <div className="mx-auto max-w-xs">
                    {/* iPhone mockup */}
                    <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                      {/* Status bar area */}
                      <div className="bg-white rounded-[2rem] overflow-hidden">
                        {/* Status bar */}
                        <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                          <span>9:41</span>
                          <div className="flex items-center space-x-1">
                            <div className="flex space-x-1">
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                              <div className="w-1 h-1 bg-black rounded-full"></div>
                            </div>
                            <div className="w-6 h-3 border border-black rounded-sm relative">
                              <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                            </div>
                          </div>
                        </div>

                        {/* Browser bar */}
                        <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                          <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                            publisher.com
                          </div>
                        </div>

                        {/* Content area */}
                        <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                          </div>
                          
                          {/* 3D Prism Ad - Full width on mobile with same gap from top */}
                          <div className="mb-6">
                            <div className="h-48 rounded-lg overflow-hidden">
                              <Prism3DAdContent 
                                isInPreview={true}
                                isExpanded={isExpanded}
                                onExpand={() => setIsExpanded(true)}
                                onClose={() => setIsExpanded(false)}
                              />
                            </div>
                          </div>
                          
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3 mt-2">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="space-y-3">
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-full"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Desktop Mockup */}
                {!isMobile && (
                  <div className="w-full max-w-2xl mx-auto">
                    {/* Desktop Screen Frame */}
                    <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                      {/* Screen */}
                      <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                        {/* macOS-style window header */}
                        <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                          <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                          </div>
                          <div className="flex-1 mx-6">
                            <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                              🔒 publisher.com
                            </div>
                          </div>
                          <div className="flex space-x-1">
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          </div>
                        </div>

                        {/* Browser content area */}
                        <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                          {/* Page header */}
                          <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                          </div>

                          {/* 3D Prism Ad positioned in content with same gap from top */}
                          <div className="flex justify-center ">
                            <div className="w-full h-64 max-w-sm ">
                              <Prism3DAdContent 
                                isInPreview={true}
                                isExpanded={isExpanded}
                                onExpand={() => setIsExpanded(true)}
                                onClose={() => setIsExpanded(false)}
                              />
                            </div>
                          </div>

                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Monitor stand */}
                    <div className="flex justify-center">
                      <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Expanded 3D Prism Overlay */}
        {isExpanded && (
          <div className="fixed inset-0 z-50">
            <Prism3DAdContent 
              isExpanded={true}
              onClose={() => setIsExpanded(false)}
            />
          </div>
        )}

        <style jsx>{`
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          .animate-slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }
          
          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }

          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
    
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <Link to="/quiz/ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/rama.webp"
                alt="Card 1"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Ramadan</h2>
              </div>
            </Link>
    
            {/* Card 2 */}
            <Link to="/dynamic-calculator/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/zakat.webp"
                alt="Card 2"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Zakat Calculator</h2>
              </div>
            </Link>
    
            {/* Card 3 */}
            <Link to="/interactive-selector/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/donation.png "
                alt="Card 3"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Donation</h2>
              </div>
            </Link>
    
            {/* Card 4 */}
            <Link to="/spin-the-wheel/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/mam1.jpg"
                alt="Card 4"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Mama Earth</h2>
              </div>
            </Link>
    
           
          </div>
        </div>
    </>
  );
}

export default Ad11;
    
    
    
    
    
    // import React, { useState } from 'react';
    // import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode } from 'lucide-react';
    
    // const Ad11 = () => {
    //   const [selectedAdId, setSelectedAdId] = useState(2);
    //   const [viewMode, setViewMode] = useState('desktop'); // 'mobile' or 'desktop'
    
    //   const adFormats = [
    //     {
    //       id: 1,
    //       name: '2025_05_Prism_...',
    //       dimension: '300x600',
    //       type: 'Banner ',
    //       creativeId: '1552639'
    //     },
        
    //   ];
    
    //   const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[0];
    
    //   const selectAd = (adId) => {
    //     setSelectedAdId(adId);
    //   };
    
    //   const nextAd = () => {
    //     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    //     const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
    //     setSelectedAdId(adFormats[nextIndex].id);
    //   };
    
    //   const prevAd = () => {
    //     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    //     const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
    //     setSelectedAdId(adFormats[prevIndex].id);
    //   };
    
    //   const AdContent = () => {
    //     return (
    //       <div className="relative">
    //         {currentAd.dimension === '300x600' && (
    //           <div className="w-full max-w-[300px] mx-auto">
    //             <div className="relative w-[300px] h-[600px] rounded-lg overflow-hidden shadow-lg">
    //               <video
    //                 autoPlay
    //                 muted
    //                 loop
    //                 playsInline
    //                 className="w-full h-full object-cover"
    //               >
    //                 <source src="/assets/prism.MP4" type="video/mp4" />
    //                 {/* Fallback gradient background */}
    //                 <div className="absolute inset-0 bg-gradient-to-br from-red-500 via-red-600 to-orange-600 flex items-center justify-center">
    //                   <div className="text-white text-center">
    //                     <div className="text-2xl mb-2">✈️</div>
    //                     <div className="text-lg font-bold">Prism</div>
    //                     <div className="text-sm">Your browser doesn't support video</div>
    //                   </div>
    //                 </div>
    //               </video>
    //             </div>
    //           </div>
    //         )}
            
         
    //       </div>
    //     );
    //   };
    
    //   return (
    //     <div className="min-h-screen bg-gray-50 flex mt-12 overflow-hidden">
    //       {/* Left Sidebar */}
    //       <div className="w-64 bg-white border-r border-gray-200 p-4 hidden lg:block">
    //         <div className="mb-6">
    //           <h2 className="text-lg font-semibold text-gray-800 mb-2">2025_05_Prism ...</h2>
    //         </div>
    
    //         <div className="mb-6">
    //           <button className="text-sm text-blue-500 hover:underline">All creatives preview</button>
    //         </div>
    
    //         <div className="space-y-2">
    //           {adFormats.map((ad) => (
    //             <div 
    //               key={ad.id}
    //               onClick={() => selectAd(ad.id)}
    //               className={`p-3 rounded-lg border cursor-pointer transition-all duration-200 hover:shadow-md ${
    //                 ad.id === selectedAdId
    //                   ? 'bg-blue-100 border-blue-300 shadow-sm' 
    //                   : 'bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300'
    //               }`}
    //             >
    //               <div className="text-sm font-medium text-gray-800 mb-2 truncate">
    //                 {ad.name}
    //               </div>
                  
    //               {/* Ad Preview Thumbnail */}
    //               <div className="mb-3 flex justify-center">
    //                 {ad.dimension === '300x600' && (
    //                   <div className="w-20 h-16 bg-gradient-to-br from-red-400 to-orange-500 rounded border shadow-sm flex items-center justify-center">
    //                     <div className="text-xs text-white font-bold">📹</div>
    //                   </div>
    //                 )}
    //                 {/* {ad.dimension === '300x600' && (
    //                   <div className="w-12 h-24 bg-gradient-to-b from-cyan-300 to-blue-400 rounded border shadow-sm flex items-center justify-center">
    //                     <div className="text-xs text-white font-bold">📹</div>
    //                   </div>
    //                 )}
    //                 {ad.dimension === '320x480' && (
    //                   <div className="w-16 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded border shadow-sm flex items-center justify-center">
    //                     <div className="text-xs text-white font-bold">📹</div>
    //                   </div>
    //                 )} */}
    //               </div>
                  
    //               <div className="space-y-1">
    //                 <div className="text-xs text-blue-500">
    //                   <span className="font-medium">Ad dimension:</span> {ad.dimension}
    //                 </div>
    //                 <div className="text-xs text-gray-600">
    //                   <span className="font-medium">Ad type:</span> {ad.type}
    //                 </div>
    //               </div>
    //             </div>
    //           ))}
    //         </div>
    //       </div>
    
    //       {/* Main Content */}
    //       <div className="flex-1 flex flex-col">
    //         {/* Header */}
    //         <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-4 flex items-center justify-between">
    //           <div className="flex items-center space-x-2 lg:space-x-4">
    //             <h1 className="text-lg lg:text-xl font-semibold text-gray-800 truncate">
    //               <span className="hidden sm:inline">2025_05_Prism...</span>
    //               <span className="sm:hidden">bidbox.ai</span>
    //             </h1>
    //             <div className="w-2 h-2 bg-gray-400 rounded-full hidden sm:block"></div>
    //           </div>
              
    //           <div className="flex items-center space-x-2 lg:space-x-4">
    //             <div className="flex items-center bg-gray-100 rounded-lg p-1">
    //               <button
    //                 onClick={() => setViewMode('mobile')}
    //                 className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
    //                   viewMode === 'mobile' 
    //                     ? 'bg-purple-600 text-white' 
    //                     : 'text-gray-600 hover:bg-gray-200'
    //                 }`}
    //               >
    //                 <Smartphone size={14} />
    //                 <span className="hidden sm:inline">Mobile</span>
    //               </button>
    //               <button
    //                 onClick={() => setViewMode('desktop')}
    //                 className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
    //                   viewMode === 'desktop' 
    //                     ? 'bg-gray-800 text-white' 
    //                     : 'text-gray-600 hover:bg-gray-200'
    //                 }`}
    //               >
    //                 <Monitor size={14} />
    //                 <span className="hidden sm:inline">Desktop</span>
    //               </button>
    //             </div>
    //           </div>
    //         </div>
    
    //         {/* Content Area */}
    //         <div className="flex-1 flex flex-col lg:flex-row">
    //           {/* Ad Preview */}
    //           <div className="flex-1 p-2 lg:p-6">
    //             {/* Navigation Buttons */}
    //             <div className="flex items-center justify-center space-x-4 lg:space-x-6 mb-4 lg:mb-6">
    //               <button 
    //                 onClick={prevAd}
    //                 className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
    //               >
    //                 <ChevronLeft size={18} />
    //                 <span className="hidden sm:inline">Prev Ad</span>
    //                 <span className="sm:hidden">Prev</span>
    //               </button>
                  
    //               <div className="text-xs lg:text-sm text-gray-500 font-medium">
    //                 {adFormats.findIndex(ad => ad.id === selectedAdId) + 1} of {adFormats.length}
    //               </div>
                  
    //               <button 
    //                 onClick={nextAd}
    //                 className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
    //               >
    //                 <span className="hidden sm:inline">Next Ad</span>
    //                 <span className="sm:hidden">Next</span>
    //                 <ChevronRight size={18} />
    //               </button>
    //             </div>
    
    //             {/* Ad Container */}
    //             <div className="w-full max-w-6xl mx-auto">
    //               {viewMode === 'mobile' ? (
    //                 // Mobile Phone Mockup
    //                 <div className="max-w-sm mx-auto">
    //                   <div className="bg-gray-800 rounded-3xl p-2 shadow-2xl">
    //                     {/* Phone Screen */}
    //                     <div className="bg-white rounded-2xl overflow-hidden" style={{aspectRatio: '9/19.5'}}>
    //                       {/* Status Bar */}
    //                       <div className="bg-white px-4 py-2 flex justify-between items-center text-xs font-semibold">
    //                         <span>10:59 AM</span>
    //                         <div className="flex items-center space-x-1">
    //                           <span className="text-xs">5G</span>
    //                           <div className="flex space-x-0.5">
    //                             <div className="w-1 h-3 bg-black rounded-full"></div>
    //                             <div className="w-1 h-3 bg-black rounded-full"></div>
    //                             <div className="w-1 h-3 bg-black rounded-full"></div>
    //                             <div className="w-1 h-2 bg-gray-300 rounded-full"></div>
    //                           </div>
    //                           <div className="w-6 h-3 border border-black rounded-sm">
    //                             <div className="w-4 h-1.5 bg-black rounded-sm m-0.5"></div>
    //                           </div>
    //                         </div>
    //                       </div>
                          
    //                       {/* App Header */}
    //                       <div className="bg-white px-4 py-3 border-b border-gray-100 flex items-center justify-between">
    //                         <div className="text-blue-600 font-bold text-lg">bidbox.ai</div>
    //                         <div className="w-6 h-6 flex flex-col justify-center space-y-1">
    //                           <div className="w-full h-0.5 bg-gray-600"></div>
    //                           <div className="w-full h-0.5 bg-gray-600"></div>
    //                           <div className="w-full h-0.5 bg-gray-600"></div>
    //                         </div>
    //                       </div>
                          
    //                       {/* Content Area */}
    //                       <div className="bg-gray-50 p-4 flex-1 flex items-center justify-center">
    //                         {/* Video Ad */}
    //                         <div className="bg-white rounded-lg p-2 shadow-sm">
    //                           <div className="text-xs text-gray-500 text-center mb-2">Video Advertisement</div>
    //                           <AdContent />
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               ) : (
    //                 // Desktop View
    //                 <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
    //                   <div className="p-8 flex items-center justify-center">
    //                     {/* Video Ad - Highlighted */}
    //                     <div className="border-2 border-dashed border-blue-300 rounded-lg p-4 bg-blue-50/30">
    //                       <div className="text-xs text-blue-600 text-center mb-2 font-medium">Prism</div>
    //                       <AdContent />
    //                     </div>
    //                   </div>
    //                 </div>
    //               )}
    //             </div>
    //           </div>
    
    //           {/* Right Sidebar */}
    //           <div className="w-80 bg-white border-l border-gray-200 p-6 hidden xl:block">
    //             <h3 className="text-lg font-semibold text-gray-800 mb-6">Video Creative Details</h3>
                
    //             <div className="space-y-6">
    //               <div className="bg-purple-50 rounded-lg p-4">
    //                 <h4 className="font-medium text-purple-800 mb-3">Video Ad Info</h4>
    //                 <div className="space-y-2 text-sm">
    //                   <div>
    //                     <span className="font-medium text-gray-700">Ad Dimension:</span>
    //                     <div className="text-gray-600">{currentAd.dimension}</div>
    //                   </div>
    //                   <div>
    //                     <span className="font-medium text-gray-700">Ad Type:</span>
    //                     <div className="text-gray-600">Video - Autoplay</div>
    //                   </div>
    //                   <div>
    //                     <span className="font-medium text-gray-700">Creative ID:</span>
    //                     <div className="text-gray-600">{currentAd.creativeId}</div>
    //                   </div>
    //                   <div>
    //                     <span className="font-medium text-gray-700">Video Properties:</span>
    //                     <div className="text-gray-600 text-xs mt-1">
    //                       <div>• Autoplay: Enabled</div>
    //                       <div>• Muted: Yes</div>
    //                       <div>• Loop: Enabled</div>
    //                       <div>• Plays Inline: Yes</div>
    //                     </div>
    //                   </div>
    //                 </div>
    //                 <button className="text-blue-500 text-sm hover:underline mt-3">
    //                   View Full-Size Video
    //                 </button>
    //               </div>
    
    //               <div className="flex justify-center">
    //                 <div className="w-32 h-32 border border-gray-300 rounded-lg flex items-center justify-center bg-white">
    //                   <QrCode size={80} className="text-gray-400" />
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    
    //       {/* Mobile Menu Button */}
    //       <div className="lg:hidden fixed bottom-4 right-4">
    //         <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg">
    //           <Monitor size={24} />
    //         </button>
    //       </div>
    //     </div>
    //   );
    // };
    
    // export default Ad11;
    
   